var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-sm btn-info",on:{"click":_vm.clipboard}},[(!_vm.loading)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "),(_vm.loading)?_c('i',{staticClass:"fa fa-cog fa-spin"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }